<template>
  <v-container fluid ma-0 pa-0 px-4 id="bucketnew-main">
    <CaseConfigHeader
      :header="header"
      :subheader="subheader"
    ></CaseConfigHeader>

    <Loading :isLoading="loading">
      <v-container fluid ma-0 px-0 pb-0 pt-4>
        <v-layout justify-start column class="mb-4">
          <div id="user edit details">
            <CaseConfig :caseType="caseType"></CaseConfig>
          </div>
        </v-layout>
      </v-container>
    </Loading>
  </v-container>
</template>

<script>
import CaseConfigHeader from "@/components/cases/case-config/CaseConfigHeader.vue";
import CaseConfig from "@/components/cases/case-config/CaseConfig.vue";
import Loading from "@/components/shared/Loading.vue";
import { mapState } from "vuex";

export default {
  name: "case-config-container",
  components: { CaseConfig, Loading, CaseConfigHeader },
  data: () => ({ title: "Configure" }),
  computed: {
    ...mapState({
      caseType: (state) => state.caseTypes.current,
      caseTypes: (state) => state.caseTypes.all,
      caseTypeId: (state) => state.cbroute.params.case_type_id,
      userLoading: (state) => state.ui.loadingActiveUser,
    }),
    loading() {
      if (this.caseType) {
        return this.userLoading;
      } else {
        return false;
      }
    },
    header() {
      if (this.loading) {
        return "Loading";
      } else {
        return `Configure ${this.caseType.name}`;
      }
    },
    subheader() {
      if (this.loading) {
        return "One moment please...";
      } else {
        return `Manage the data definition, tasks, and process milestones.`;
      }
    },
  },
  watch: {
    caseTypes() {
      this.reload();
    },
    caseTypeId() {
      this.reload();
    },
  },
  methods: {
    async reload() {
      if (this.caseTypeId) {
        await this.$store.dispatch("setupCaseType", this.caseTypeId);
      }
    },
  },
};
</script>
